import styled from 'styled-components';

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-relative-xs);
  column-gap: var(--spacing-relative-xs);

  & + & {
    margin-top: var(--spacing-relative-lg);
  }
`;

export const StyledFieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;

export const StyledLegend = styled.legend`
  padding-inline: 0;
  padding-bottom: ${({ theme }) => theme.spacing.fixed150};
`;
